<template>
  <div v-if="!isEnabled">
    <div
      v-if="
        hasRegister && !hasGateway 
      "
      v-test="'booking-settings-onlinePaymentWarning'"
    >
      <BaseAlert
        v-if="description"
        color="info"
        :text="description"
        :secondaryAction="{
          text: $t('admin.booking.enable_payment_button'),
          routerLink: { name: 'integrations' }
        }"
        v-test="'enable-payment-banner'"
      />
    </div>
    <BaseAlert
      v-if="!hasRegister"
      color="warning"
      :text="$t('admin.booking.upgrade_warning')"
      :primaryAction="{
        text: $t('admin.booking.upgrade_button'),
        routerLink: { name: 'subscription' }
      }"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { computed, watch } from 'vue';
import { useUserStore } from '@/stores/user';

defineProps<{
  modelValue: boolean;
  description?: string;
}>();

const emit = defineEmits(['update:modelValue']);

const { result: currentUser } = useQuery(
  gql`
    query getCurrentUser {
      currentUser {
        company {
          paymentGateway
        }
      }
    }
  `,
  null,
  {
    fetchPolicy: 'cache-first',
  },
);

const { hasFeatureFlag } = useUserStore();

const hasGateway = computed(
  () => !!currentUser.value?.currentUser.company.paymentGateway,
);
const hasRegister = computed(() => hasFeatureFlag('module-register'));

const isEnabled = computed(() => hasRegister.value && hasGateway.value);
watch(
  isEnabled,
  (isEnabled) => {
    emit('update:modelValue', isEnabled);
  },
  {
    immediate: true,
  },
);
</script>
